import React, { memo, useCallback, useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import { PropTypes } from "prop-types";

import StopFilterButton from "./Button";
import { FILTER_TITLES, SHOW_ME_ALL } from "../../../constants/strings";
import FILTERS from "../../../enums/RouteDetailFilters";
import { isFilterDisabled } from "../../../features/routeDetail/model";
import { ChevronIcon } from "../../icons";
import MOVE_TYPES from "../../../enums/moveTypes";
import { Text, View } from "../../Base";
import { useOverlay } from "../../Overlay";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    margin: `0 ${typography.pxToRem(20)}`,
  },
  title: {
    fontSize: typography.pxToRem(16),
  },
}));

const Filters = memo(
  ({ filteredStops, filters, toggleFilter, moveStops, moveButtonsState }) => {
    const classes = useStyles();
    const { showOverlayWhile } = useOverlay();

    const filtersButtons = useMemo(
      () =>
        Object.values(FILTERS).map((id) => {
          if (id === FILTERS.SHOW_IN_ROUTE) {
            return {
              id,
              value: FILTER_TITLES.SHOW_IN_ROUTE,
              selected:
                filters.length > 1 && filters.includes(FILTERS.SHOW_IN_ROUTE),
              disabled: filters.length < 1,
              rightButton: true,
            };
          }

          const selected = filters.includes(id);
          const disabled = !selected && isFilterDisabled(id, filteredStops);

          return {
            id,
            value: FILTER_TITLES[id],
            selected,
            disabled,
          };
        }),
      [filteredStops, filters]
    );

    const moveStopsUp = useCallback(async () => {
      await moveStops(MOVE_TYPES.UP);
    }, [moveStops]);
    const moveStopsDown = useCallback(async () => {
      await moveStops(MOVE_TYPES.DOWN);
    }, [moveStops]);

    return (
      <View className={classes.container}>
        <Text noWrap className={classes.title}>
          {SHOW_ME_ALL}
        </Text>
        {filtersButtons.map((button, i) => (
          <StopFilterButton key={i} {...button} onClick={toggleFilter} />
        ))}
        <StopFilterButton
          disabled={moveButtonsState[MOVE_TYPES.UP]}
          onClick={showOverlayWhile(moveStopsUp)}
          value={<ChevronIcon />}
        />
        <StopFilterButton
          disabled={moveButtonsState[MOVE_TYPES.DOWN]}
          onClick={showOverlayWhile(moveStopsDown)}
          value={<ChevronIcon down />}
        />
      </View>
    );
  }
);

Filters.propTypes = {
  filteredStops: PropTypes.array.isRequired,
  filters: PropTypes.array.isRequired,
  toggleFilter: PropTypes.func.isRequired,
  moveStops: PropTypes.func.isRequired,
  moveButtonsState: PropTypes.object.isRequired,
};

export default Filters;
